import { Star } from "lucide-react";
import { type QuizConfig } from "~/types/quiz";

export const testSamopouzdanja: QuizConfig = {
  id: "test-samopouzdanja",
  illustration: {
    src: "/images/quizzes/test-samopouzdanja-v2.webp",
    alt: "Žena se priprema da iznese svoje mišljenje na sastanku.",
  },
  lastModified: "2026-07-18",
  title: "Besplatan test samopouzdanja | Koliko veruješ u sebe?",
  shortTitle: "Test samopouzdanja",
  description:
    "Otkrij šta te blokira, kako govoriš sa sobom i u kojim situacijama gubiš sigurnost. Dobijaš personalizovane savete za jačanje samopouzdanja. Traje 3-5 min.",
  longDescription:
    "Otkrij šta se dešava sa tvojim samopouzdanjem kada se pojave kritika, iznenadne promene ili poruke koje te vraćaju korak unazad. Test analizira kako govoriš sa sobom, šta te blokira i koje situacije te lako izbace iz balansa. Na kraju dobijaš personalizovane tehnike za svakodnevno jačanje samouverenosti, ideje kako da pohvališ sebe kada ti je najpotrebnije i način da postaviš granice bez griže savesti.",
  icon: Star,
  duration: "3-5 min",
  category: "Ličnost i emocije",
  focusAreasWanted: [
    "self_esteem",
    "self_development",
    "boundaries",
    "emotional_regulation",
  ],
  questions: [
    {
      type: "radio",
      question: "Koliko često sumnjaš u svoje sposobnosti?",
      options: ["Nikad", "Retko", "Ponekad", "Često", "Stalno"],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "radio",
      question: "Kako se osećaš kada pričaš pred drugima?",
      options: [
        "Skroz opušteno",
        "Uglavnom opušteno",
        "Onako",
        "Neprijatno",
        "Baš neprijatno",
      ],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "checkbox",
      checkboxScoring: "sum",
      question: "Šta te čini nesigurnim/om? (označi sve što važi)",
      options: [
        "Javni nastupi",
        "Druženje sa ljudima",
        "Poslovni izazovi",
        "Veze i zabavljanje",
        "Važne odluke",
        "Kako izgledaš",
        "Ništa me ne čini nesigurnim/om",
      ],
      scores: [1, 1, 1, 1, 1, 1, 0],
    },
    {
      type: "radio",
      question: "Koliko ti je bitno šta drugi misle?",
      options: [
        "Nije mi bitno",
        "Malo mi je bitno",
        "Onako",
        "Dosta mi je bitno",
        "Previše mi je bitno",
      ],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "textarea",
      question:
        "Šta bi voleo/la da promeniš kod sebe da bi bio/la samopouzdaniji/a?",
    },
    {
      type: "radio",
      question: "Kako reaguješ kada napraviš grešku?",
      options: [
        "Učim iz nje i idem dalje",
        "Malo me muči, ali prođe",
        "Dugo razmišljam o tome",
        "Baš me pogodi",
        "Danima se loše osećam",
      ],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "radio",
      question: "Koliko često kažeš 'ne' drugima?",
      options: [
        "Kad god mi nešto ne odgovara",
        "Često, ali mi nije uvek lako",
        "Ponekad",
        "Retko, teško mi je",
        "Skoro nikad",
      ],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "checkbox",
      checkboxScoring: "sum",
      question: "Šta te čini ponosnim/om? (označi sve što važi)",
      options: [
        "Moji uspesi na poslu/faksu",
        "Kako se nosim sa teškim situacijama",
        "Odnosi sa ljudima",
        "Moje veštine i talenti",
        "Kako izgledam",
        "Moje odluke u životu",
        "Ništa posebno",
      ],
      scores: [1, 1, 1, 1, 1, 1, 0],
    },
    {
      type: "radio",
      question: "Kako se osećaš kad treba da probaš nešto novo?",
      options: [
        "Jedva čekam",
        "Uzbuđeno, ali pozitivno",
        "Malo me frka",
        "Baš me hvata trema",
        "Izbegavam nove stvari",
      ],
      scores: [4, 3, 2, 1, 0],
    },
  ],
  copy: {
    title: "Kako stojiš sa samopouzdanjem",
    subtitle: "Analiza tvog samopouzdanja",
    scoreLabel: "Rezultat:",
    adviceTitle: "Kako da ojačaš samopouzdanje",
    resourcesTitle: "Korisni materijali",
    whatNextTitle: "Šta dalje",
    shareButtonText: "Podeli rezultat",
  },
};
